export default class AccessLocalStorage {
    getItem(key) {
        return localStorage.getItem(key);
    }

    setItem(key, value) {
        return localStorage.setItem(key, value);
    }

    removeItem(key) {
        return localStorage.removeItem(key);
    }

    removeOTPSentCount() {
        this.removeItem("otpsent");
    }

    removeReferralOTPSentCount() {
        this.removeItem("referralotpsent");
    }

    removeOTPSentDate() {
        this.removeItem("otpsentdate");
    }
    removeReferralOTPSentDate() {
        this.removeItem("referralotpsentdate");
    }

    setOTPSentCount(value) {
        this.setItem("otpsent", value);
        this.setOTPSentDate();
    }

    setReferralOTPSentCount(value) {
        this.setItem("referralotpsent", value);
        this.setReferralOTPSentDate();
    }

    getOTPSentCount() {
        if (localStorage.getItem("otpsent") !== null)
            return parseInt(localStorage.getItem("otpsent"), 10);
        else
            return 0;
    }

    getReferralOTPSentCount() {
        if (localStorage.getItem("referralotpsent") !== null)
            return parseInt(localStorage.getItem("referralotpsent"), 10);
        else
            return 0;
    }

    isTeacher() {
        const authTokens = localStorage.getItem("authTokens");
        
        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            return parsedAuthTokens?.professionalType === 3;
        }
        return false;
    }

    isPediatrician() {
        const authTokens = localStorage.getItem("authTokens");
        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            return parsedAuthTokens?.professionalType === 1;
        }
        return false;
    }

    isAdmin() {
        const authTokens = localStorage.getItem("authTokens");
        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            return parsedAuthTokens?.email === "saran@enrichmycare.com";
        }
    }

    setOTPSentDate() {
        this.setItem("otpsentdate", Date.now());
    }

    setReferralOTPSentDate() {
        this.setItem("referralotpsentdate", Date.now());
    }

    getOTPSentDate() {
        if (this.getItem("otpsentdate") != null)
            return new Date(parseInt(this.getItem("otpsentdate"), 10));
        else
            return null;
    }

    getReferralOTPSentDate() {
        if (this.getItem("referralotpsentdate") != null)
            return new Date(parseInt(this.getItem("referralotpsentdate"), 10));
        else
            return null;
    }

    getProfessional() {
        if (this.getItem("authTokens") != null) {
            let obj = JSON.parse(this.getItem("authTokens"));
            return {
                title: obj.title !== undefined ? obj.title : "",
                name: obj.name !== undefined ? obj.name : "",
                profession: obj.profession !== undefined ? obj.profession : ""
            };
        }
        return { title: "", name: "", profession: "" };
    }

    setProfessional(data) {
        if (this.getItem("authTokens") != null) {
            let obj = JSON.parse(this.getItem("authTokens"));
            obj.title = data.title;
            obj.name = data.name;
            obj.profession = data.profession;
            localStorage.setItem("authTokens", JSON.stringify(obj));
        }
    }

    setCurrentPatient(obj) {
        this.setItem("currentpatient", JSON.stringify(obj));
    }

    getToken(){
        const authTokens = localStorage.getItem("authTokens");
        let token = "";

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }

        return token;
    }

    getCurrentPatient() {
        if (this.getItem("currentpatient") != null)
            return JSON.parse(this.getItem("currentpatient"));
        else
            return null;
    }

    getLoggedInEmail() {
        if (this.getItem("authTokens") != null) {
            let obj = JSON.parse(this.getItem("authTokens"));
            return obj.email;
        }
        return "";
    }

    getCurrentPatientId() {
        let cp = this.getCurrentPatient();
        if (cp !== null) {
            return cp.user.id;
        } else
            return "00000000-0000-0000-0000-000000000000";
    }

    hoursPassedSinceLastOTPSent() {
        if (this.getOTPSentDate() != null) {
            const date1 = this.getOTPSentDate();
            const date2 = Date.now();
            const diffTime = Math.abs(date2 - date1);
            const diffHours = diffTime / (1000 * 60 * 60);
            return diffHours;
        }
        return -1;
    }

    hoursPassedSinceLastReferralOTPSent() {
        if (this.getReferralOTPSentDate() != null) {
            const date1 = this.getReferralOTPSentDate();
            const date2 = Date.now();
            const diffTime = Math.abs(date2 - date1);
            const diffHours = diffTime / (1000 * 60 * 60);
            return diffHours;
        }
        return -1;
    }
}